import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './ProductDetail.css';
import { FaWhatsapp, FaTiktok, FaCertificate, FaGem, FaGavel, FaCheckCircle, FaCrown, FaAward, FaTimes, FaSearchPlus } from 'react-icons/fa';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

const ProductDetail = () => {
  const { productId } = useParams(); 
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImg, setActiveImg] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal kontrolü kanka

  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, "products"), 
          where("id", "==", productId), 
          limit(1)
        );
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          setProduct(querySnapshot.docs[0].data());
        }
      } catch (err) {
        console.error("Hata:", err);
      }
      setLoading(false);
    };

    fetchProduct();
    window.scrollTo(0, 0);
  }, [productId]);

  // Modal açıkken arkadaki sayfanın kaymasını engelle kanka
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isModalOpen]);

  if (loading) return <div className="product-detail-page"><div className="loading">Hazine İnceleniyor...</div></div>;
  if (!product) return <div className="product-detail-page"><div className="loading">Eser bulunamadı kral.</div></div>;

  const waNumber = "905453669008"; 
  const waMessage = `Merhaba, #${product.id} kodlu "${product.name}" eseri hakkında bilgi alabilir miyim?`;
  const waLink = `https://wa.me/${waNumber}?text=${encodeURIComponent(waMessage)}`;

  const allImages = product.allImages && product.allImages.length > 0 
    ? product.allImages 
    : [product.img];

  const renderFeatureCards = () => {
    const cards = [];
    if (product.cat === 'damla-kehribar') {
      cards.push(<div key="gem" className="f-card"><FaGem /> Doğal Fosilli</div>);
    } else {
      cards.push(<div key="gem" className="f-card"><FaGem /> Hakiki Malzeme</div>);
    }

    if (product.cat === 'osmanli-sikma') {
      cards.push(<div key="status" className="f-card"><FaAward /> Antika Değer</div>);
    } else if (product.price?.toLowerCase().includes('özel')) {
      cards.push(<div key="status" className="f-card"><FaCrown /> Nadir Seri</div>);
    } else {
      cards.push(<div key="status" className="f-card"><FaGavel /> Koleksiyonluk</div>);
    }

    const isUstaIsi = product.name?.toLowerCase().includes('usta') || 
                      product.description?.toLowerCase().includes('usta') ||
                      product.cat === 'usta-iscilik-kuka';

    if (isUstaIsi) {
      cards.push(<div key="check" className="f-card" style={{borderColor: 'var(--bronze-light)'}}><FaCheckCircle /> Usta İmzalı</div>);
    } else {
      cards.push(<div key="check" className="f-card"><FaCertificate /> %100 Orijinal</div>);
    }
    return cards;
  };

  return (
    <div className="product-detail-page">
      <Navbar />
      
      <div className="detail-container">
        
        {/* SOL: GALERİ BÖLÜMÜ */}
        <div className="gallery-section">
          <div className="main-image-viewport" onClick={() => setIsModalOpen(true)}>
            <img src={allImages[activeImg]} alt={product.name} />
            <div className="zoom-hint">
                <FaSearchPlus /> BÜYÜTMEK İÇİN TIKLA
            </div>
          </div>
          
          {allImages.length > 1 && (
            <div className="thumbnail-strip">
              {allImages.map((img, index) => (
                <div 
                  key={index} 
                  className={`thumb-item ${activeImg === index ? 'active' : ''}`}
                  onClick={() => setActiveImg(index)}
                >
                  <img src={img} alt={`${product.name} önizleme ${index}`} />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* SAĞ: BİLGİ ALANI */}
        <div className="info-section">
          <div className="info-header">
            <span className="stock-label">LOT NO: #{product.id}</span>
            <h1 className="product-name">{product.name}</h1>
            <div className="price-tag">Fiyat: {product.price}</div>
          </div>

          <div className="feature-cards">
            {renderFeatureCards()}
          </div>

          <div className="detail-specs">
            <h3>Teknik Özellikler</h3>
            <div className="spec-grid">
              <div className="spec-item"><span>Malzeme</span> <strong>{product.material || 'Özel Seçki'}</strong></div>
              <div className="spec-item"><span>Kesim</span> <strong>{product.cut || 'Özel Kesim'}</strong></div>
              <div className="spec-item"><span>Ölçü</span> <strong>{product.measure || 'Yüksek Kondisyon'}</strong></div>
            </div>
          </div>

          <div className="product-description">
  <h3>Eser Hakkında</h3>
  <p>{product.description || 'Bu eşsiz eser hakkında detaylı bilgi almak için bizimle iletişime geçebilirsiniz.'}</p>
</div>

          <div className="action-box">
            <p className="action-note">Bu eser için canlı mezata katılabilir veya hemen WhatsApp üzerinden teklif verebilirsiniz.</p>
            <div className="btn-group">
              <a href={waLink} target="_blank" rel="noreferrer" className="wa-btn">
                <FaWhatsapp /> WHATSAPP İLE TEKLİF VER
              </a>
              <a href="https://www.tiktok.com/@tesbihcimen.collection" target="_blank" rel="noreferrer" className="tt-btn">
                <FaTiktok /> CANLI MEZATI TAKİP ET
              </a>
            </div>
          </div>

          <div className="guarantee-footer">
            <FaCertificate className="cert-icon" />
            <p>
              Tesbihcimen koleksiyonundaki her eser, orijinallik ve malzeme kalitesi 
              konusunda uzman incelemesinden geçmiştir.
            </p>
          </div>
        </div>
      </div>

      {/* --- LIGHTBOX MODAL --- */}
      {isModalOpen && (
        <div className="image-lightbox" onClick={() => setIsModalOpen(false)}>
          <button className="close-lightbox"><FaTimes /></button>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <img src={allImages[activeImg]} alt="Büyük Görünüm" />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ProductDetail;